import type { ReactElement, ReactNode } from 'react';

import { Text } from '../../Text';

export interface BaseHeaderProps {
  /** H1 heading for the main content. */
  heading?: string;
  /** Content to render after the heading, usually a paragraph. */
  subHeading?: ReactNode;
  /** Image to render above the heading. */
  image?: ReactElement;
}

export function BaseHeader(props: BaseHeaderProps) {
  if (!props.heading && !props.subHeading && !props.image) {
    return <></>;
  }
  return (
    <header>
      {props.image}
      {props.heading && (
        <Text variant="heading-40" as="h1" vSpacing="none" bold color="Kale3">
          {props.heading}
        </Text>
      )}
      {props.subHeading && (
        <Text as="p" variant="heading-22" topSpacing="md" bottomSpacing="lg">
          {props.subHeading}
        </Text>
      )}
    </header>
  );
}
